import { Stack } from "@mui/system";
import EmptyListSlot from "../Misc/EmptyListSlot";
import { Table } from "@mui/material";
import { Inventory2, Inventory2Outlined } from "@mui/icons-material";


export function TableNoRows() {
    return (
        <Stack flex="1 1 0" height="100%" alignItems="center" justifyContent="center">

            <EmptyListSlot
                title="No data available"
                desc="There are no rows to display."
                icon={<Inventory2Outlined />}
                sx={{ width: "100%", height: "100%", background: "transparent !important" }}
            />
        </Stack>
    )
}